import type { Customers_Bool_Exp } from '@gql/base-types';

export interface HomeRooftopsWhereInput {
  /** The working rooftop's organization; absent when the rooftop has none. */
  organizationId: number | undefined;
  /** The rooftops the viewer is linked to; empty means unscoped (an admin). */
  allowedIds: number[];
  workingRooftopId: number;
}

/**
 * With no organization, an unscoped viewer gets the working rooftop alone, so the list never
 * spans customers the viewer has no business seeing.
 */
export function homeRooftopsWhere({ organizationId, allowedIds, workingRooftopId }: HomeRooftopsWhereInput): Customers_Bool_Exp {
  const where: Customers_Bool_Exp = { active: { _eq: 1 } };
  if (organizationId !== undefined) where.organization_id = { _eq: organizationId };
  if (allowedIds.length > 0) where.id = { _in: allowedIds };
  else if (organizationId === undefined) where.id = { _eq: workingRooftopId };
  return where;
}
